const debounce = (function () {
  let timer = 0
  return function (func, delay) {
    clearTimeout(timer)
    timer = setTimeout(func, delay)
  }
})()

export {debounce}



// WEBPACK FOOTER //
// ./src/utils/debounce.js